/* eslint-disable */
import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import MyAccountHeader from "Components/MyAccount/Header/MyAccountHeader";
import MyAccountBody from "Components/MyAccount/MyAccountBody/MyAccountBody";

const MyAccount = () => {
  return (
    <>
      <Header />
      <section className="inner_sec">
        <div className="container">
          <MyAccountHeader />
          <div className="accont_innr">
            <MyAccountBody />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default MyAccount;
